/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Banner } from '@neo4j-ndl/react';

const Component = () => {
  return (
    <div className="n-flex n-flex-col n-gap-token-8">
      <Banner variant="info" hasIcon={true}>
        <Banner.Header>Info</Banner.Header>
        <Banner.Description>This is a banner of type info.</Banner.Description>
      </Banner>
      <Banner variant="success" hasIcon={true}>
        <Banner.Header>Success</Banner.Header>
        <Banner.Description>
          This is a banner of type success.
        </Banner.Description>
      </Banner>
      <Banner variant="warning" hasIcon={true}>
        <Banner.Header>Warning</Banner.Header>
        <Banner.Description>
          This is a banner of type warning.
        </Banner.Description>
      </Banner>
      <Banner variant="danger" hasIcon={true}>
        <Banner.Header>Danger</Banner.Header>
        <Banner.Description>
          This is a banner of type danger.
        </Banner.Description>
      </Banner>
      <Banner variant="neutral" hasIcon={true}>
        <Banner.Header>Neutral</Banner.Header>
        <Banner.Description>
          This is a banner of type neutral.
        </Banner.Description>
      </Banner>
    </div>
  );
};

export default Component;
